module.exports = __webpack_public_path__ + "static/media/undraw_time.6e294233.svg";